
(() => {
  if (window.LavezziStickyCartLoaded) return;
  window.LavezziStickyCartLoaded = true;

  const instances = new Map();

  function initStickyCart(bar) {
    const sectionId = bar.dataset.sectionId;
    const section = document.getElementById(
      `MainProduct-${sectionId}`
    );

    if (!section) return;

    const info = section.querySelector(
      `#ProductInfo-${sectionId}`
    );

    const variantsElement = document.getElementById(
      `LavezziVariants-${sectionId}`
    );

    let variants = [];

    try {
      variants = JSON.parse(
        variantsElement?.textContent || "[]"
      );
    } catch (error) {
      console.error("Sticky cart variant data error", error);
    }

    const variantsById = new Map(
      variants.map((variant) => [
        String(variant.id),
        variant
      ])
    );

    const stickyButton = bar.querySelector(
      "[data-sticky-add-button]"
    );
    const stickyButtonText = bar.querySelector(
      "[data-sticky-button-text]"
    );
    const quantityText = bar.querySelector(
      "[data-sticky-quantity]"
    );
    const priceText = bar.querySelector(
      ".lavezzi-sticky-cart__price"
    );
    const image = bar.querySelector(
      ".lavezzi-sticky-cart__image"
    );

    const getOriginalButton = () =>
      info?.querySelector(
        `#ProductSubmitButton-${sectionId}`
      );

    const getOriginalForm = () =>
      document.getElementById(
        `product-form-${sectionId}`
      );

    const getQuantityInput = () =>
      document.getElementById(
        `Quantity-${sectionId}`
      );

    const getVariantInput = () =>
      getOriginalForm()?.querySelector(
        'input[name="id"]'
      );

const stickyOptions = [
  ...bar.querySelectorAll("[data-sticky-option-index]")
];

const stickyQtyInput = bar.querySelector(
  "[data-sticky-qty-input]"
);

const stickyMinus = bar.querySelector(
  "[data-sticky-minus]"
);

const stickyPlus = bar.querySelector(
  "[data-sticky-plus]"
);

function getOriginalOptionControls() {
  const picker = section.querySelector("variant-selects");

  if (!picker) return [];

  return [...picker.children].filter((child) =>
    child.matches("fieldset, .product-form__input--dropdown")
  );
}

function updateOriginalOption(index, value) {
  const container = getOriginalOptionControls()[index];

  if (!container) return;

  const dropdown = container.querySelector("select");

  if (dropdown) {
    const option = [...dropdown.options].find(
      (item) => item.value === value
    );

    if (!option) return;

    dropdown.value = value;
    dropdown.dispatchEvent(
      new Event("change", { bubbles: true })
    );
    return;
  }

  const radio = [...container.querySelectorAll(
    'input[type="radio"]'
  )].find((input) => input.value === value);

  if (!radio || radio.disabled) return;

  radio.checked = true;
  radio.dispatchEvent(
    new Event("change", { bubbles: true })
  );
}

function syncStickyOptions() {
  const controls = getOriginalOptionControls();

  stickyOptions.forEach((stickySelect, index) => {
    const container = controls[index];
    if (!container) return;

    const dropdown = container.querySelector("select");

    const selectedValue = dropdown
      ? dropdown.value
      : container.querySelector(
          'input[type="radio"]:checked'
        )?.value;

    if (selectedValue !== undefined) {
      stickySelect.value = selectedValue;
    }
  });
}

function syncStickyQuantity() {
  const original = getQuantityInput();
  if (!original || !stickyQtyInput) return;

  stickyQtyInput.value = original.value;
  stickyQtyInput.min = original.min || "1";
  stickyQtyInput.step = original.step || "1";

  if (original.max) {
    stickyQtyInput.max = original.max;
  } else {
    stickyQtyInput.removeAttribute("max");
  }
}

function setOriginalQuantity(requested) {
  const original = getQuantityInput();
  if (!original) return;

  const min = Number(original.min) || 1;
  const max = original.max
    ? Number(original.max)
    : Infinity;
  const step = Number(original.step) || 1;

  if (!Number.isFinite(requested)) {
    syncStickyQuantity();
    return;
  }

  const normalized = Math.min(
    max,
    Math.max(min, min + Math.round(
      (requested - min) / step
    ) * step)
  );

  original.value = String(normalized);

  original.dispatchEvent(
    new Event("input", { bubbles: true })
  );
  original.dispatchEvent(
    new Event("change", { bubbles: true })
  );

  syncStickyQuantity();
  scheduleUpdate();
}

// Sticky color / size selectors
stickyOptions.forEach((select, index) => {
  select.addEventListener("change", () => {
    updateOriginalOption(index, select.value);
    scheduleUpdate();
  });
});

// Sticky quantity buttons
stickyMinus?.addEventListener("click", () => {
  const original = getQuantityInput();
  if (!original) return;

  setOriginalQuantity(
    Number(original.value) - (Number(original.step) || 1)
  );
});

stickyPlus?.addEventListener("click", () => {
  const original = getQuantityInput();
  if (!original) return;

  setOriginalQuantity(
    Number(original.value) + (Number(original.step) || 1)
  );
});

stickyQtyInput?.addEventListener("change", () => {
  setOriginalQuantity(Number(stickyQtyInput.value));
});

    const getPriceElement = () =>
      document.getElementById(
        `price-${sectionId}`
      );

    let updateScheduled = false;

    function updateStickyCart() {
      updateScheduled = false;
syncStickyOptions();
syncStickyQuantity();
      const originalButton = getOriginalButton();
      const variantInput = getVariantInput();
      const quantityInput = getQuantityInput();

      if (!originalButton || !variantInput) {
        bar.classList.remove("is-visible");
        bar.setAttribute("aria-hidden", "true");
        return;
      }

      // Synchronize quantity
      if (quantityText) {
        quantityText.textContent =
          quantityInput?.value || "1";
      }

      // Read the variant from Dawn's real product form
      const variant = variantsById.get(
        String(variantInput.value)
      );

      // Synchronize variant image
      if (variant?.featured_image?.src && image) {
        const imageUrl = variant.featured_image.src;

        if (image.dataset.currentSrc !== imageUrl) {
          image.src = imageUrl;
          image.dataset.currentSrc = imageUrl;
        }
      }

      // Synchronize the currently displayed price
      const priceElement = getPriceElement();

      if (priceElement && priceText) {
        const salePrice = priceElement.querySelector(
          ".price__sale .price-item--sale"
        );

        const regularPrice = priceElement.querySelector(
          ".price__regular .price-item--regular"
        );

        const isSale = priceElement.querySelector(
          ".price--on-sale"
        );

        const displayedPrice = isSale
          ? salePrice
          : regularPrice || salePrice;

        if (displayedPrice?.textContent.trim()) {
          priceText.textContent =
            displayedPrice.textContent.trim();
        }
      }

      // Let Dawn determine availability and errors.
      stickyButton.disabled = originalButton.disabled;

      const originalText = originalButton.querySelector(
        "span"
      );

      if (originalText && stickyButtonText) {
        stickyButtonText.textContent =
          originalText.textContent.trim();
      }

      // Only show after scrolling past original button
      updateVisibility();
    }

    function updateVisibility() {
      const originalButton = getOriginalButton();

      if (!originalButton) return;

      const rect = originalButton.getBoundingClientRect();

      const shouldShow =
        rect.bottom < 0 &&
        rect.width > 0 &&
        document.body.contains(originalButton);

      bar.classList.toggle("is-visible", shouldShow);

      bar.setAttribute(
        "aria-hidden",
        shouldShow ? "false" : "true"
      );
    }

    function scheduleUpdate() {
      if (updateScheduled) return;

      updateScheduled = true;

      requestAnimationFrame(updateStickyCart);
    }

    function handleStickyClick() {
      const originalButton = getOriginalButton();

      if (
        !originalButton ||
        originalButton.disabled ||
        stickyButton.disabled
      ) {
        return;
      }

      // Use the native Dawn product form.
      // Dawn handles AJAX, cart drawer, and errors.
      originalButton.click();

      scheduleUpdate();
    }

    stickyButton.addEventListener(
      "click",
      handleStickyClick
    );

    // Update quantity, variant selection, etc.
    section.addEventListener(
      "change",
      scheduleUpdate
    );

    section.addEventListener(
      "input",
      scheduleUpdate
    );

    // Dawn re-renders parts of product information
    // after a variant change. Observe those updates.
    const observer = new MutationObserver(
      scheduleUpdate
    );

    if (info) {
      observer.observe(info, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: [
          "disabled",
          "value",
          "class"
        ]
      });
    }

    window.addEventListener(
      "scroll",
      updateVisibility,
      { passive: true }
    );

    window.addEventListener(
      "resize",
      updateVisibility
    );

    // Keep the button state synced during loading
    // and after cart operations.
    const syncInterval = setInterval(() => {
      if (!bar.isConnected) {
        cleanup();
        return;
      }

      scheduleUpdate();
    }, 500);

    function cleanup() {
      clearInterval(syncInterval);
      observer.disconnect();

      window.removeEventListener(
        "scroll",
        updateVisibility
      );

      window.removeEventListener(
        "resize",
        updateVisibility
      );

      stickyButton.removeEventListener(
        "click",
        handleStickyClick
      );

      section.removeEventListener(
        "change",
        scheduleUpdate
      );

      section.removeEventListener(
        "input",
        scheduleUpdate
      );

      instances.delete(sectionId);
    }

    instances.set(sectionId, {
      bar,
      cleanup
    });

    updateStickyCart();
  }

  function initializeAll() {
    document.querySelectorAll(
      ".lavezzi-sticky-cart"
    ).forEach((bar) => {
      const id = bar.dataset.sectionId;
      const existing = instances.get(id);

      if (existing?.bar === bar) return;

      if (existing) existing.cleanup();

      initStickyCart(bar);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeAll
    );
  } else {
    initializeAll();
  }

  // Support Shopify theme-editor section reloads
  document.addEventListener(
    "shopify:section:load",
    initializeAll
  );
})();

document.addEventListener("click", async (event) => {
  const button = event.target.closest("[data-sticky-buy-now]");
  if (!button || button.disabled) return;

  const sticky = button.closest(".lavezzi-sticky-cart");
  if (!sticky) return;

  const sectionId = sticky.dataset.sectionId;
  const variantsElement = document.getElementById(
    `LavezziVariants-${sectionId}`
  );

  if (!variantsElement) return;

  const variants = JSON.parse(variantsElement.textContent);

  const selectedOptions = Array.from(
    sticky.querySelectorAll("[data-sticky-option-index]")
  ).map((select) => select.value);

  const variant = variants.find((item) =>
    selectedOptions.length === 0 ||
    selectedOptions.every(
      (value, index) => item.options[index] === value
    )
  );

  if (!variant || !variant.available) {
    alert("This variant is unavailable.");
    return;
  }

  const quantityInput = sticky.querySelector(
    "[data-sticky-qty-input]"
  );

  const quantity = Number(quantityInput?.value || 1);

  if (!Number.isInteger(quantity) || quantity < 1) {
    alert("Please select a valid quantity.");
    return;
  }

  const previousText = button.textContent;
  button.disabled = true;
  button.textContent = "PROCESSING...";

  try {
    const root = window.Shopify?.routes?.root || "/";

    const response = await fetch(`${root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        items: [{
          id: variant.id,
          quantity: quantity
        }]
      })
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.description || "Unable to add product.");
    }

    window.location.href = `${root}checkout`;

  } catch (error) {
    alert(error.message || "Something went wrong.");
    button.disabled = false;
    button.textContent = previousText;
  }
});

/* LAVEZZI - LIVE CART COUNTER UPDATE */

async function refreshLavezziCartCount() {
  try {
    const root = window.Shopify?.routes?.root || "/";

    const response = await fetch(`${root}cart.js`, {
      cache: "no-store"
    });

    if (!response.ok) return;

    const cart = await response.json();
    const cartIcon = document.querySelector("#cart-icon-bubble");

    if (!cartIcon) return;

    let bubble = cartIcon.querySelector(".cart-count-bubble");

    if (cart.item_count === 0) {
      bubble?.remove();
      return;
    }

    if (!bubble) {
      bubble = document.createElement("div");
      bubble.className = "cart-count-bubble";
      bubble.innerHTML = `
        <span aria-hidden="true"></span>
        <span class="visually-hidden"></span>
      `;
      cartIcon.appendChild(bubble);
    }

    const count = bubble.querySelector(
      "span[aria-hidden='true']"
    );

    const accessibleCount = bubble.querySelector(
      ".visually-hidden"
    );

    if (count) {
      count.textContent =
        cart.item_count < 100 ? cart.item_count : "";
    }

    if (accessibleCount) {
      accessibleCount.textContent =
        `${cart.item_count} items`;
    }

  } catch (error) {
    console.error("Lavezzi cart update error:", error);
  }
}

/* Listen for successful Dawn cart additions */

if (
  typeof subscribe === "function" &&
  typeof PUB_SUB_EVENTS !== "undefined"
) {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event?.source === "product-form") {
      refreshLavezziCartCount();
    }
  });
}

/* LAVEZZI - PRODUCT PAGE BUY NOW */

document.addEventListener("click", async function (event) {
  const button = event.target.closest(
    "[data-lavezzi-product-buy-now]"
  );

  if (!button || button.disabled) return;

  const form = button.closest('form[action*="/cart/add"]');
  if (!form) return;

  const originalButton = form.querySelector(
    '[name="add"]'
  );

  if (originalButton?.disabled) return;
  if (!form.reportValidity()) return;

  const data = new FormData(form);

  const section = button.closest("product-info");

  const sectionId = section?.dataset.section;

  const quantityInput = sectionId
    ? document.getElementById(`Quantity-${sectionId}`)
    : null;

  if (quantityInput) {
    data.set("quantity", quantityInput.value);
  } else if (!data.has("quantity")) {
    data.set("quantity", "1");
  }

  const variantId = data.get("id");

  if (!variantId) {
    alert("Please select a product variant.");
    return;
  }

  const originalText = button.textContent;

  button.disabled = true;
  button.textContent = "PROCESSING...";

  try {
    const root = window.Shopify?.routes?.root || "/";

    const response = await fetch(`${root}cart/add.js`, {
      method: "POST",
      body: data,
      headers: {
        Accept: "application/json"
      }
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.description || "Unable to add product."
      );
    }

    window.location.assign(`${root}checkout`);

  } catch (error) {
    console.error("Buy Now error:", error);

    alert(error.message || "Something went wrong.");

    button.disabled = false;
    button.textContent = originalText;
  }
});
